<div class="aura__wrapper" [ngClass]="themeOverride" *ngIf="!isLoading; else loading">
  <aura-chat
    class="w-100 h-100"
    [config]="chatConfig"
    [userId]="userId"
    [selectedAgent]="selectedAgent"
    [context]="context"
    [language]="language"
    [historyHost]="host"
    [analyticsContext]="analyticsContext"
    [isThemeDark]="isThemeDark"
    (agentChange)="onAgentChange($event)"
    (themeToggle)="onThemeToggle()"
    (analyticsEvent)="onAnalyticsEvent($event)"
    (responseReceived)="onResponseReceived($event)"
  ></aura-chat>
</div>

<!-- loading -->
<ng-template #loading>
    <div class="w-100 h-100">
        <div class="aura__loader h-100">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
        </div>
    </div>
</ng-template>
